import { ChevronRight, PlayCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { Product } from '../Product/productData';

function ProductRow({ product }: { product: Product }) {
  return (
    <li title={product.secondary} className="group relative flex min-h-14 items-center gap-3 border-t border-white/[0.07] px-3 py-2 transition-colors lg:min-h-12 lg:py-1.5 first:border-t-0 hover:bg-white/[0.05] focus-within:bg-white/[0.05] active:bg-white/[0.08]">
      <Link
        to={product.to}
        aria-label={product.primary}
        className="absolute inset-0 z-10 outline-none focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-primary"
      />
      {product.icon ? (
        <span aria-hidden className="w-7 shrink-0 select-none text-center text-xl leading-none">
          {product.icon}
        </span>
      ) : null}
      <span className="min-w-0 flex-1">
        <span className="block truncate text-[0.95rem] font-medium leading-snug text-foreground">{product.primary}</span>
        <span className="block truncate text-[0.8125rem] leading-snug text-muted-foreground">{product.summary}</span>
      </span>
      {product.twitterLink ? (
        <a
          href={product.twitterLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Watch a demo of ${product.primary}`}
          title="Watch a demo"
          className="relative z-20 -my-1 inline-flex size-11 shrink-0 items-center justify-center rounded-md text-white/60 transition-colors hover:bg-white/10 hover:text-white lg:size-8"
        >
          <PlayCircle aria-hidden className="size-4" />
        </a>
      ) : null}
      <ChevronRight aria-hidden className="size-4 shrink-0 text-white/40" />
    </li>
  );
}

/** The full list for one shelf: each row keeps its summary and demo link. */
export default function ProductCatalog({ products }: { products: Product[] }) {
  return (
    <ul className="w-full overflow-hidden rounded-2xl bg-[#111] shadow-[inset_0_0_0_1px_rgba(255,255,255,0.07)]">
      {products.map((product) => (
        <ProductRow key={product.to} product={product} />
      ))}
    </ul>
  );
}
